









import { State, Getter, Action } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Searchable } from '@/mixins/searchable';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    TableBase: () => import('@/components/table/base.vue'),
  },
})
export default class PageOrder extends Searchable<Order> {
  @Getter('order/all') orders!: Order[];

  @Getter('workspace/selected') workspace!: Workspace;

  @Action('order/index') indexOrders!: (payload: { query: IndexQuery<Order>; workspaceId: number }) => Promise<Order[]>;

  localOrders: Order[] = [];

  i18n: string = 'views.orders.index';

  searchItemsProperty = 'orders';

  tableLayout = {
    settings: {
      locale_path: `${this.i18n}.table`,
      max_height: 'calc(100% - 80px)',
      clickable: true,
    },
    structure: [
      {
        key: 'id',
        value: (model: Order) => `#${model.id}`,
        width: 75,
      },
      {
        key: 'created_at',
        value: (model: Order) => {
          // @ts-ignore
          return this.$moment(model.created_at).calendar();
        },
        width: 200,
      },
      {
        key: 'client.first_name',
        value: (model: Order) => `${model.client.first_name} ${model.client.last_name}`,
        width: 200,
      },
      {
        key: 'client.company_name',
        value: (model: Order) => model.client.company_name,
        width: 200,
      },
      {
        key: 'total',
        value: (model: Order) => {
          let total = 0;
          model.order_products.forEach((orderProduct: OrderProduct) => {
            total += orderProduct.price * orderProduct.quantity + orderProduct.price_tax_total;
          });
          // @ts-ignore
          total += model.shipping_costs + model.shipping_costs_tax;
          // @ts-ignore
          total += model.transaction_costs + model.transaction_costs * model.shipping_costs_tax_rate;

          const keyValues: { [key: string]: { price: number; price_tax: number } } = model.additional_costs ?? {};
          const additionalCosts = Object.keys(model.additional_costs ?? {}).map((key) => ({ key, price: keyValues[key].price, price_tax: keyValues[key].price_tax }));
          // @ts-ignore
          total += additionalCosts.reduce((sum: number, additionalCost) => sum + additionalCost.price_tax + additionalCost.price, 0);

          return `€${(Math.round((total + Number.EPSILON) * 100) / 100).toFixed(2)}`;
        },
        width: 200,
        sortable: false,
      },
      {
        key: 'status',
        value: (model: Order) => this.$t(`options.order_status.${model.status}`),
        width: 200,
      },
      {
        key: 'client.vat_valid',
        value: (model: Order) => {
          if (model.client.type !== 'company') {
            return '';
          }
          if (model.client.vat_valid === null) {
            return '<span class="badge-label blue">In afwachting</span>';
          }
          if (model.client.vat_valid === false) {
            return '<span class="badge-label red">Ongeldig</span>';
          }
          if (model.client.vat_valid === true) {
            return '<span class="badge-label green">Geldig</span>';
          }
          return '';
        },
        width: 200,
      },
      {
        key: 'shipping_method',
        value: (model: Order) => this.$t(`options.shipping_method.${model.shipping_method}`),
        width: 200,
      },
    ],
  };

  handleSort(item: any) {
    this.sorting = item;
    this.indexOrders({ query: { per_page: 20, s: this.sortQuery }, workspaceId: this.workspace.id });
  }

  loadMore() {
    this.indexOrders({ query: { per_page: 20, after: this.lastAfter, s: this.sortQuery }, workspaceId: this.workspace.id });
  }

  @Watch('orders', { immediate: true })
  ordersChanged(val: Order[]) {
    this.localOrders = val;
  }

  @Watch('workspace')
  workspaceChanged(val: Workspace) {
    this.indexOrders({ query: { per_page: 20 }, workspaceId: this.workspace.id });
  }
}
